export const phoneMaxLength = 10;

export const kycValidationConstants = {
    heading: `# KYC Validation`,
    subHeading: `### Please fill out the details below to submit your KYC information`,
    activateCardText: `${process.env.REACT_APP_ACTIVATE_CARD_TEXT}`,
    kycValidationSubText: `To ensure a successful KYC (Know Your Customer) check, please make sure to provide accurate and up-to-date personal details during the verification process.  These details must match the details on your license or passport exactly`,
    phoneNumberSubText: `${process.env.REACT_APP_PHONE_SUB_TEXT}`,
    activateCardButtonText: `Activate Now`,
    termsConditionsCheckValue: 'true',
    termsConditionsText: `I understand and agree to the gift card [Terms & Conditions*](${process.env.REACT_APP_TERMS_LINK})`,
    defaultValue: {
        cardID: '',
        firstName: '',
        middleName: '',
        lastName: '',
        licenseNo: '',
        passportNo: '',
        day: '',
        month: '',
        year: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        postcode: '',
        country: 'Australia',
      phoneNumber: '',
        
    },
    validations: {
        cardID: {
            id: 'cardID',
            required: 'Card ID is required',
            format: 'Card ID is required'
        },
        firstName: {
            id: 'firstName',
            required: 'First given name is required',
            format: 'First given name is required'
        },
        middleName: {
            id: 'middleName',
            required: 'Middle name is required',
            format: 'Middle name must only contain letters'
        },
        lastName: {
            id: 'lastName',
            required: 'Last name is required',
            format: 'Last name is required'
        },
        licenseNo: {
            id: 'licenseNo',
            required: 'License number is required',
            format: 'License number must be a number'
        },
        passportNo: {
            id: 'passportNo',
            required: 'Passport number is required',
            format: 'Passport number is required'
        },
        day: {
            id: 'day',
            required: 'Day is required',
            format: 'Day is required'
        },
        month: {
            id: 'month',
            required: 'Month is required',
            format: 'Month is required'
        },
        year: {
            id: 'year',
            required: 'Year is required',
            format: 'Year is required'
        },
        addressLine1: {
            id: 'addressLine1',
            required: 'Address is required',
            format: 'Address is required'
        },
        city: {
            id: 'city',
            required: 'City is required',
            format: 'City is required'
        },
        state: {
            id: 'state',
            required: 'State is required',
            format: 'State is required'
        },
        postcode: {
            id: 'postcode',
            required: 'Postcode is required',
            format: 'Postcode is required'
        },
        country: {
            id: 'country',
            required: 'Country is required',
            format: 'Country is required'
        },
        phoneNumber: {
            id: 'phoneNumber',
            required: 'Phone number is required for OTP authentication',
            format: 'Phone number is required for OTP authentication'
  },
    }
}
export const kycVerificationValidationConstants = {
  heading: `# KYC Verification`,
  subHeading: `To activate and use this card we require KYC (Know Your Customer) verification due to Anti-Money Laundering and Counter-Terrorism Financing regulations.`,
  bodyText: `We have made this process simple and secure using GreenID, Australia's largest online identity verification platform. To verify your ID, enter your full name, current address and date of birth. You may be directed to provide identification via greenID. If you have any questions or are unable to validate your identity via the greenID portal, please contact us at info@vaultps.com.au or (03) 9000 0012`,
  activateCardText: `${process.env.REACT_APP_ACTIVATE_CARD_TEXT}`,
  kycValidationSubText: `To ensure a successful KYC check, please make sure to provide accurate and up-to-date personal details during the verification process.  These details must match the details on your license or passport exactly`,
  cardIDSubText: `Not sure where to find Unique Card ID or Activation Code? [See here](https://vaultps.zendesk.com/hc/en-au/articles/18164404242191-Where-to-find-your-Unique-Card-ID-EAID)`,
  phoneNumberSubText: `${process.env.REACT_APP_PHONE_SUB_TEXT}`,
  consentText: `I confirm that I am authorised to provide the personal details presented and I consent to my information being checked with the document issuer or official record holder via third party systems for the purpose of confirming my identity.`,
  termsConditionsCheckValue: 'true',
  termsConditionsText: `I understand and agree to the gift card [Terms & Conditions*](${process.env.REACT_APP_TERMS_LINK})`,
  defaultValue: {
    cardID: '',
    firstName: '',
    middleName: '',
    lastName: '',
    day: '',
    month: '',
    year: '',
    phoneNumber: '',
    flatNumber: '',
    streetNumber: '',
    streetName: '',
    streetType: '',
    suburb: '',
    state: '',
    postcode: '',
    country: 'Australia',
    consentGranted: false,
  },
  validations: {
    consentGranted: {
      id: 'consentGranted',
      required: 'You must provide consent to continue',
    },
    cardID: {
      id: 'cardID',
      required: 'Card ID is required',
      format: 'Card ID is required',
    },
    firstName: {
      id: 'firstName',
      required: 'First given name is required',
      format: 'First given name is required',
    },
    middleName: {
      id: 'middleName',
      required: 'Middle name is required',
      format: 'Middle name must only contain letters',
    },
    lastName: {
      id: 'lastName',
      required: 'Last name is required',
      format: 'Last name is required',
    },
    day: {
      id: 'day',
      required: 'Day is required',
      format: 'Day is required',
    },
    month: {
      id: 'month',
      required: 'Month is required',
      format: 'Month is required',
    },
    year: {
      id: 'year',
      required: 'Year is required',
      format: 'Year is required',
    },
    streetName: {
      id: 'streetName',
      required: 'Street name is required',
      format: 'Street name is required',
    },
    flatNumber: {
      id: 'flatNumber',
      format: 'If flat number is provided, it must be a number',
    },
    streetNumber: {
      id: 'streetNumber',
      required: 'Street number is required',
      format: 'Street number is required',
    },
    streetType: {
      id: 'streetType',
      required: 'Street type is required',
      format: 'Street type is required',
    },
    suburb: {
      id: 'suburb',
      required: 'Suburb is required',
      format: 'Suburb is required',
    },
    state: {
      id: 'state',
      required: 'State is required',
      format: 'State is required',
    },
    postcode: {
      id: 'postcode',
      required: 'Postcode is required',
      format: 'Postcode is required',
    },
    country: {
      id: 'country',
      required: 'Country is required',
      format: 'Country is required',
    },
  },
};